import {
  FieldValues,
  useController,
  useFormContext,
  type FieldPath,
} from 'react-hook-form';
import { LegalClientTypeInput } from './LegalClientTypeInput';

type FieldProps<TValues extends FieldValues> = {
  name: FieldPath<TValues>;
};

export function LegalClientTypeField<TValues extends FieldValues>({
  name,
}: FieldProps<TValues>) {
  const { control } = useFormContext<TValues>();
  const {
    field: { value, onChange },
  } = useController({
    name,
    control,
  });
  return <LegalClientTypeInput value={value as number} onChange={onChange} />;
}
